export default (siteName) => [
    {
        path: 'tool/business-tax-txt-viewer',
        name: 'business-tax-txt-viewer',
        component: () => import('../../components/dashboard/Tool/BusinessTaxTxtViewer/IndexPage.vue'),
        meta: {
            title: `營業稅媒體檔檢視器${siteName}`,
            activeMenu: 'declaration',
        },
    },
    {
        path: 'tool/log',
        name: 'log-tool',
        component: () => import('../../components/dashboard/Tool/Log/IndexPage.vue'),
        meta: {
            title: `DebugTool${siteName}`,
            activeMenu: '',
        },
    },
];
